import { useState } from 'react';
import { Dialog } from '@headlessui/react';
import html2pdf from 'html2pdf.js';
import GratitudeLetter from './Gratitude';

export default function GratitudePreviewModal({ selected, onClose }) {
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(null);

    const url = process.env.REACT_APP_URL;
    const handleSendEmail = async () => {
        setLoading(true);
        setSuccess(null);

        try {
            const element = document.getElementById('gratitude-preview');

            // const opt = {
            //     margin: 0.5,
            //     filename: 'gratitude-letter.pdf',
            //     html2canvas: { scale: 2 },
            //     jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
            // };

            const opt = {
                margin: [0.2, 0.5, 0.2, 0.5], // top, right, bottom, left
                filename: 'gratitude-letter.pdf',
                html2canvas: { scale: 1.8 }, // slightly lower scale
                jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
                pagebreak: { mode: ['avoid-all'] }
            };

            // Wait for PDF blob generation
            const blob = await html2pdf().set(opt).from(element).outputPdf('blob');

            // Sanity check
            // console.log("📄 Blob size:", blob.size);

            if (blob.size < 1000) {
                alert("❌ PDF is too small. Ensure preview content is fully rendered.");
                setLoading(false);
                return;
            }

            const file = new File([blob], 'gratitude-letter.pdf', { type: 'application/pdf' });
            const formData = new FormData();
            // console.log(selected.donor.email);

            formData.append('file', file);
            formData.append('to', selected.donor.email);
            formData.append('name', selected.donor.name);
            formData.append('year', selected.currentYear);

            const response = await fetch(url + `/send-gratitude-pdf`, {
                method: 'POST',
                body: formData,
            });

            const result = await response.json();
            if (result.success) {
                setSuccess(true);
            } else {
                setSuccess(false);
                alert("❌ Server responded with failure.");
            }
        } catch (err) {
            console.error("❌ Error sending email:", err);
            setSuccess(false);
        } finally {
            setLoading(false);
        }
    };


    return (
        <Dialog open={!!selected} onClose={onClose} className="fixed z-50 inset-0 overflow-y-auto">
            <div className="flex items-center justify-center min-h-screen px-4">
                <Dialog.Panel className="bg-white rounded-lg shadow-lg w-full max-w-4xl p-6 relative">
                    <Dialog.Title className="text-lg font-bold mb-4">Gratitude Letter Preview</Dialog.Title>

                    <div className="max-h-[70vh] overflow-y-auto">
                        <div id="gratitude-preview">
                            <GratitudeLetter data={selected?.donor} year={selected?.currentYear} />
                        </div>
                    </div>

                    <div className="mt-4 flex justify-end gap-4">
                        <button
                            className="bg-gray-300 text-black px-4 py-2 rounded hover:bg-gray-400"
                            onClick={onClose}
                        >
                            Cancel
                        </button>
                        <button
                            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 disabled:opacity-50"
                            onClick={handleSendEmail}
                            disabled={loading}
                        >
                            {loading ? "Sending..." : "Send Email"}
                        </button>
                    </div>

                    {success === true && <p className="text-green-600 mt-2">Email sent successfully!</p>}
                    {success === false && <p className="text-red-600 mt-2">Failed to send email.</p>}
                </Dialog.Panel>
            </div>
        </Dialog>
    );
}
